import { createContext, useContext } from 'react';

export const UrlParamContext = createContext();

export const useUrlParamContext = () => {
  return useContext(UrlParamContext);
};
